// Tiny origin badges for customer notes: typed in Ontik vs synced from the merchant's ERP.
// Used by the Recent Activity feed and the trade-account Timeline.

export function OntikBadge() {
  return (
    <span title="Created in Ontik" className="shrink-0">
      <img src="/favicon.svg" alt="Ontik" className="size-3.5 rounded-[3px]" />
    </span>
  );
}

export function ErpBadge() {
  return (
    <span title="Synced from your ERP" className="shrink-0">
      <svg viewBox="0 0 12 12" fill="none" className="size-3.5" role="img" aria-label="ERP">
        <path
          d="M0 2.4C0 1.07344 1.07344 0 2.4 0H9.6C10.9266 0 12 1.07344 12 2.4V9.6C12 10.9266 10.9266 12 9.6 12H2.4C1.07344 12 0 10.9266 0 9.6V2.4Z"
          fill="#1047AA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.08633 3.9543H3.96133V2.88086H8.08633V3.9543ZM5.26914 6.46914V7.9457H8.12148V9.01914H3.95898V5.3957H7.88242V6.46914H5.26914Z"
          fill="white"
        />
      </svg>
    </span>
  );
}

// `source` is the NoteSource name as a string ("Ontik" | "Erp") — the BFF sends the enum
// name, not the number. Numeric enum values are tolerated as a fallback.
// Unknown/missing → no badge.
export default function NoteSourceBadge({ source }) {
  if (source === "Erp" || source === 1) return <ErpBadge />;
  if (source === "Ontik" || source === 0) return <OntikBadge />;
  return null;
}
